import Layout from "components/base/Layout";
import HistoryList from "components/biz/HistoryList";

export default function History() {
  return (
    <Layout>
      <HistoryList />
    </Layout>
  );
}